export const FIELD_TYPE_SHORT_DATE = 'shortDate';
export const FIELD_TYPE_DATE_TIME = 'dateTme';
export const FIELD_TYPE_EXTERNAL_LINK = 'externalLink';
export const FIELD_TYPE_CONDITIONAL_ICON = 'conditional icon';
export const FIELD_TYPE_STRING_REPLACE = 'String Replace';
export const FIELD_TYPE_INTERNAL_LINK = 'internLink';

export default {  
  FIELD_TYPE_SHORT_DATE,
  FIELD_TYPE_DATE_TIME,
  FIELD_TYPE_EXTERNAL_LINK,
  FIELD_TYPE_CONDITIONAL_ICON,
  FIELD_TYPE_STRING_REPLACE,
  FIELD_TYPE_INTERNAL_LINK
}
